import { EditionsService } from './../../services/editions.service';
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Inject
} from '@angular/core';

import { EditionsDataSource } from './../../datasources/editions-data-source';
import { SelectionModel } from '@angular/cdk/collections';
import { Edition } from './../../models/edition.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { AdminNewEditionComponent } from './../admin-new-edition/admin-new-edition.component';

@Component({
  selector: 'app-admin-editions',
  templateUrl: './admin-editions.component.html',
  styleUrls: ['./admin-editions.component.scss']
})
export class AdminEditionsComponent implements OnInit, AfterViewInit {
  dataSource: EditionsDataSource;
  displayedColumns = [
    'publishDates',
    'closeDate',
    'status',
    'count',
    'actions'
  ];

  selection = new SelectionModel<Edition>(true, []);
  viewOnlyActive = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private editionsService: EditionsService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.dataSource = new EditionsDataSource(this.editionsService);
    this.dataSource.loadEditions(null, null);
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadEditions();
    });
    this.paginator.page.pipe(tap(() => this.loadEditions())).subscribe();
  }

  loadEditions() {
    this.dataSource.loadEditions(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize
    );
  }

  changeOnlyActive() {
    this.viewOnlyActive = !this.viewOnlyActive;
    this.loadEditions();
  }

  openNewEditionModule() {
    const dialogRef = this.dialog.open(AdminNewEditionComponent, {
      width: '600px',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadEditions();
    });
  }

  deleteEdition(id: string) {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '300px',
      data: { editionId: id },
      autoFocus: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadEditions();
    });
  }
}

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: 'confirm-delete-dialog.html',
  styleUrls: ['./admin-editions.component.scss']
})
export class ConfirmDeleteDialogComponent implements OnInit {
  id: string;
  constructor(
    private editionsService: EditionsService,
    public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.id = this.data.editionId;
  }

  close(): void {
    this.dialogRef.close();
  }

  deleteEdition() {
    this.editionsService.deleteEdition(this.id).subscribe(data => this.close());
  }
}
